export default {"src":"/_next/static/media/joignable.b342a29d.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};